export default __webpack_public_path__ + "static/media/searchIcon.3c90afb6.svg";